import { gql } from '@apollo/client';

export const IvrFoldersQuery = gql`
  query IvrFolders {
    getIvrFolders
  }
`;

export const IvrFilesQuery = gql`
  query IvrFiles($path: String!) {
    getIvrFiles(path: $path) {
      name
      files {
        name
        updatedAt
        url
      }
    }
  }
`;

export const UpdateCampaignIvrUrlsMutation = gql`
  mutation UpdateCampaignIvrUrls(
    $campaignId: ID!
    $input: UpdateCampaignIvrUrlsInput!
    $companyId: ID!
  ) {
    updateCampaignIvrUrls(campaignId: $campaignId, input: $input, companyId: $companyId) {
      campaignId
      campaignName
      inboundIvrAudioUrl
      scheduledIvrAudioUrl
      unscheduledIvrAudioUrl
    }
  }
`;
